import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';

import { MessageModalComponent } from '../components/message-modal/message-modal.component';
import { YesNoCancelDialogData, YesNoCancelModalComponent, YesNoCancelModalResult, } from '../components/yes-no-cancel-modal/yes-no-cancel-modal.component';
import { YesNoModalComponent } from '../components/yes-no-modal/yes-no-modal.component';
import { DetailsModalData, ModalData, ValidationModalData } from '../models';
import { SendValidationModalComponent } from '../components/send-validation-error-modal/send-validation-modal.component';
import { filter, flatMap } from 'rxjs/operators';
import { MessageModalWithDetailsComponent } from '../components/message-modal-with-details/message-modal-with-details.component';
import {YesNoInfoModalComponent} from '../components/yes-no-info-modal/yes-no-info-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NotifyService {

  constructor(private dialog: MatDialog) { }

  yesNoModal(message: string | { message: string, title: string } | ModalData): Observable<boolean> {
    const dialogRef: MatDialogRef<YesNoModalComponent> = this.dialog.open(YesNoModalComponent, {
      data: message,
      panelClass: 'modal'
    });

    return dialogRef.afterClosed();
  }

  yesNoInfoModal(message: string | { message: string, title: string } | DetailsModalData): Observable<boolean> {
    const dialogRef: MatDialogRef<YesNoInfoModalComponent> = this.dialog.open(YesNoInfoModalComponent, {
      data: message,
      panelClass: 'modal'
    });

    return dialogRef.afterClosed();
  }

  yesNoCancelModal(data: YesNoCancelDialogData): Observable<YesNoCancelModalResult> {
    const dialogRef: MatDialogRef<YesNoCancelModalComponent> = this.dialog.open(YesNoCancelModalComponent, {
      data: data,
      panelClass: 'modal'
    });

    return dialogRef.afterClosed();
  }

  infoModal(message: string | { message: string, title: string } | ModalData): Observable<void> {
    const dialogRef: MatDialogRef<MessageModalComponent> = this.dialog.open(MessageModalComponent, {
      data: message,
      panelClass: 'modal'
    });

    return dialogRef.afterClosed();
  }

  errorModal(message: string | { message: string, title: string } | ModalData): Observable<void> {
    const dialogRef: MatDialogRef<MessageModalComponent> = this.dialog.open(MessageModalComponent, {
      data: message,
      panelClass: ['modal', 'modal--warn']
    });

    return dialogRef.afterClosed();
  }

  errorWithInfoModal(message: string | { message: string, title: string } | DetailsModalData): Observable<void> {
    const dialogRef: MatDialogRef<MessageModalWithDetailsComponent> = this.dialog.open(MessageModalWithDetailsComponent, {
      data: message,
      panelClass: ['modal', 'modal--warn']
    });

    return dialogRef.afterClosed();
  }

  errorValidationModal(message: string | { message: string, title: string } | ValidationModalData): Observable<void> {
    const dialogRef: MatDialogRef<SendValidationModalComponent> = this.dialog.open(SendValidationModalComponent, {
      data: message,
      panelClass: ['modal', 'modal--schematronError']
    });

    return dialogRef.afterClosed();
  }

  closeAllModals(): void {
    this.dialog.closeAll();
  }

  afterAllClosed(): Observable<void> {
    return this.dialog.afterAllClosed;
  }
}
